/**
 * Triggers MV animation
 */

const mvTypingAnimation = function() {
  const spanElems = document.querySelectorAll(".lp__mv-heading span");
  const txts = [`Hello,‎`, `I am‎`, `Ton!`];
  const speed = 70;
  var i = 0;
  var j = 0;
  var k = 0;
  
  function typeWriter(curr, index) {
    if (curr < txts[index].length) {
      spanElems[index].innerHTML += txts[index].charAt(curr);
      curr++;
      setTimeout(() => typeWriter(curr, index), speed);
    }
  }
  
  // First span
  typeWriter(i, 0);

  // Second span
  setTimeout( () => {
    typeWriter(j, 1);
  }, 490)

  // Third span
  setTimeout( () => {
    typeWriter(k, 2);
  }, 840)
  
  // Circle 
  setTimeout( () => {
    spanElems[2].classList.add('circle');
  }, 1200)
  
  // Highlight 
  const subheading = document.querySelector(".lp__mv-subheading span");
  setTimeout( () => {
    subheading.classList.add("highlight");
  }, 1300)
}

export default mvTypingAnimation;